import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import apiUtils from '../../services/apiUtils';

const ProtectedRoute = () => {
    const { isAuthenticated } = useSelector(state => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    useEffect(() => {
        // Проверка валидности токена
        const verifyToken = async () => {
            if (!isAuthenticated) {
                navigate('/performance-admin-panel/login');
            }
            else {
                // Проверка токена путем запроса к защищенному маршруту
                // Если токен неверный, перехватчик в apiUtils автоматически 
                // вызовет logout и обновит состояние isAuthenticated
                await apiUtils.get('/api/auth/validate');
            }
        }

        verifyToken();
    }, [isAuthenticated, navigate, dispatch]);
    
    return isAuthenticated ? <Outlet /> : null;
};

export default ProtectedRoute;